export default {   
    //Card Brands
    allBrands: 'mastercard,visa,amex,discover',
    
    //Theme Button
    darkMode: false,
  
    //Close Button
    displayCloseButton: false,

    //OK Button
    displayOkButton: true,

    // Locale
    defaultLocale: 'en-US'
  };
  